import { render, staticRenderFns } from "./new-fax.vue?vue&type=template&id=3589e14b"
import script from "./new-fax.vue?vue&type=script&lang=js"
export * from "./new-fax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports